export default class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.modalRef = React.createRef();
    this._performClose = this._performClose.bind(this);
  }
  
  _performClose() {
      $('#mySidenav').css("z-index","3");
      this.modalRef.current.classList.add("remove-modal");
      setTimeout(() => {
          if(typeof globalFunctions.onModalClose !== "undefined") {
            globalFunctions.onModalClose();
          }          
          this.props.hideModal();
          delete globalFunctions.onModalClose;
      }, 350);
  }

  render() {
    var sourceType = this.props.sourceType;

    // var imageURL = site_url + "/uploads/" + this.props.url.substring(this.props.url.lastIndexOf('/') + 1) + "?q=" + new Date().getTime();
    if (this.props.url.indexOf("?") >= 0 || (sourceType != undefined && (sourceType == 6 || sourceType == 9 || sourceType == 10 || sourceType == 11))){
      if(this.props.archiveURL != undefined && this.props.archiveURL != ""){
        var imageURL = site_url + "/" + this.props.archiveURL;
      }else{
        var imageURL = site_url + "/" + this.props.url;
      }
    }else{
      var imageURL = site_url + "/" + this.props.url + "?q=" + new Date().getTime();
    }

      return (
            <div ref={this.modalRef} id={this.props.id} className="chain-modal" onClick={(e) => e.stopPropagation()}>
                <div className="chain-modal-content">
                    <div className="chain-modal-header">{this.props.header}</div>
                    {
                        this.props.hideModalCloseIcon 
                            ? null
                            : <i className="icon close chain-close" onClick={() => this._performClose()}> </i>
                    }
                    {
                        this.props.hideShareButton
                            ? null
                            : <button style={{position: 'absolute',top: 20,right: 72}} 
                            onClick={() => globalFunctions.displayTinyUrl(imageURL,sourceType)
                            //window.open(site_url + '/' + this.props.url, '_blank')
                        }><i class="share square icon"></i> Share</button>
                    }
                    <div id="content" style={{flexWrap: 'wrap',height: '-webkit-fill-available', height: '89%'}}>{this.props.content}</div>
                    <div className="chain-modal-footer">{this.props.footer}</div>
                </div>
            </div>
        );
  }
}



// WEBPACK FOOTER //
// ./frontend/web/js/Modal.js